<template>
    <el-header
        class="main_header"
        :style="{ 'z-index': isMenuDrawer ? '2001' : '' }"
    >
        <div class="header-left">
            <!-- <el-button :class="[isMenuDrawer?'el-icon-s-grid':'el-icon-menu']"
                 type="primary"
            @click="handleChangeMenuDrawer"></el-button>-->
            <router-link class="logoCont" :to="{ name: 'home' }">
                <img
                    class="logoImg"
                    src="../../assets/image/header/logo.png"
                    alt="logo"
                    srcset
                />
                <!-- <span class="logoTitle">CMOFFER</span> -->
            </router-link>

            <div class="search">
                <el-input
                    v-model="keyword"
                    size="mini"
                    shape="round"
                    placeholder="Search Dropshipping Products to Sell"
                    @keyup.enter.native="findProduct"
                ></el-input>
                <el-button
                    type="primary"
                    round
                    size="mini"
                    @click="findProduct"
                >
                    <i class="el-icon-search" />
                </el-button>
            </div>
        </div>
        <div class="header-right">
            <div v-if="corpName" class="welcome">Welcome, <br/>{{ corpName }}</div>
            <!-- <div class="authorized">
                <stores :platformList="platformList" placement="bottom-end">
                    <div class="store-img">
                        <img src="@/assets/image/store.svg" />
                        <span>Integrations</span>
                    </div>
                </stores>
            </div> -->
            <div>
                <el-popover
                placement="bottom"
                width="230"
                trigger="click">
                <div>
                    <span><i class="el-icon-user"></i> {{contactUserName}}</span><br>
                    <span><i class="el-icon-message"></i> <a :href="`mailto:${contactEmail}`" style="padding-left:5px">{{contactEmail}}</a></span>
                </div>
                <span slot="reference" style="text-decoration: underline;cursor:pointer;font-size:14px;padding-right:10px;">CONTACT US</span>
                </el-popover>
            </div>
            <div class="cart" @click="toshoppingCart">
                <i class="el-icon-shopping-cart-2"></i>
                <span ref="cart-num" class="cart-num" v-if="cart > 0">{{
                    cart
                }}</span>
            </div>
            <!-- <el-dropdown trigger="click" @command="languageChange">
                <span class="el-dropdown-link languageSpan">
                    {{ this.language }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="zh">中文</el-dropdown-item>
                    <el-dropdown-item command="en">English</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown> -->
            <!-- <div class="questionCont"
           @click="openHelp">
        <el-badge class="item">
          <div style="display:flex">
            <i class="el-icon-question"></i>
            <p style="width: 28px;height: 20px;line-height: 20px;">帮助</p>
          </div>
        </el-badge>
      </div>
      <div class="downloadCont"
           @click="download">
        <el-badge is-dot
                  class="item">
          <i class="el-icon-download"></i>
        </el-badge>
            </div>-->
            <!-- <div class="alarmCont"
           @click="alarm">
        <el-badge is-dot
                  class="item">
          <i class="iconfont icon-alarm"></i>
        </el-badge>
            </div>-->
            <el-dropdown @command="handleCommand">
                <div class="userinfo">
                    <div>
                        <el-avatar
                            shape="circle"
                            size="small"
                            :src="headImgSrc"
                        ></el-avatar>
                        <span class="userName">{{
                            /*"My Account" */userInfo.name || userName
                        }}</span>
                    </div>
                    <el-dropdown-menu class="dropdown" slot="dropdown">
                        <!-- <el-dropdown-item command="setting">
                            <i class="iconfont icon-geren"></i>
                            {{ $i18n.locale == "en" ? "Setting" : "个人设置" }}
                        </el-dropdown-item>
                        <el-dropdown-item command="changePwd">
                            <i class="iconfont icon-change_password"></i>
                            {{ $i18n.locale == "en" ? "Change password" : "修改密码" }}
                        </el-dropdown-item> -->
                        <el-dropdown-item command="logout">
                            <i class="iconfont icon-tuichu"></i>
                            {{ $i18n.locale == "en" ? "Log out" : "退出登录" }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </div>
            </el-dropdown>
        </div>

        <setting :settingVisible.sync="settingVisible"></setting>
        <myTask :myTaskVisible.sync="myTaskVisible"></myTask>
        <changePass :passwordVisible.sync="passwordVisible"></changePass>
        <add
            :addVisible.sync="addVisible"
            :id="platform_id"
            @successCloseDialog="successCloseDialog"
        ></add>
        <auth
            :authVisible.sync="authVisible"
            :tableItem="tableItem"
            :authKeyList.sync="authKeyList"
        ></auth>
    </el-header>
</template>
<script>
import setting from "./header/setting";
import myTask from "./header/myTask";
import changePass from "./header/changePass";
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState } from "vuex";
import add from "@/views/pages/storePlatform/storeList/add";
import auth from "@/views/pages/storePlatform/storeList/auth";
import stores from "@/common/components/stores.vue";
let ORDERINFO = {};
export default {
    data() {
        return {
            headImgSrc:
                "https://cube.elemecdn.com/9/c2/f0ee8a3c7c9638a54940382568c9dpng.png",
            userName: localStorage.getItem("last_name"),
            corpName: localStorage.getItem("corp_name"),
            settingVisible: false,
            passwordVisible: false,
            myTaskVisible: false,
            language: "English",
            platformList: [],
            authKeyList: [],
            platform_id: null,
            addVisible: false,
            authVisible: false,
            cart: 0,
            authorizedStore: false,
            keyword: "",
            tableItem: {},
            contactUserName:"",
            contactEmail:"",
        };
    },
    components: {
        add: add,
        auth: auth,
        setting: setting,
        myTask: myTask,
        changePass: changePass,
        stores,
    },
    computed: {
        ...mapState({
            menu_id: (state) => state.menu.menu_id,
            userInfo: (state) => state.login.userInfo,
            menuList: (state) => state.login.menuList,
            cartNum: (state) => state.login.cartNum,
            isMenuDrawer: (state) => state.menu.isMenuDrawer,
        }),
        menuBread() {
            return this.$store.state.menu.menuBread.length
                ? this.$store.state.menu.menuBread
                : JSON.parse(localStorage.getItem("menuBread"));
        },
    },
    methods: {
        /**
         * 全局语言改变
         * */
        languageChange(value) {
            if (value == "zh") {
                this.$i18n.locale = "zh";
                this.language = "中文";
            } else if (value == "en") {
                this.$i18n.locale = "en";
                this.language = "English";
            }
        },
        /**
         * 登出  修改密码  个人设置
         */
        handleCommand(command) {
            if (command == "logout") {
                this.logout();
            } else if (command == "changePwd") {
                this.passwordVisible = true;
            } else if (command == "setting") {
                this.settingVisible = true;
            }
        },
        /**
         * 退出
         */
        logout() {
            // this.$confirm("确定退出此系统吗?", "提示", {
            //     confirmButtonText: "确定",
            //     cancelButtonText: "取消",
            //     type: "warning",
            // })
            //     .then(() =>
            cmofferApi.logout({}).then((res) => {
                if (res) {
                    // this.$message.success("退出成功");
                    localStorage.clear();
                    sessionStorage.clear();
                    this.$router.push("/login");
                    this.$store.commit("INDEX_COLLAPSE", false);
                }
            });
            // )
            // .catch(() => {
            //     this.$message.info("已取消退出操作");
            // });
        },
        /**
         * 收起还是展开
         */
        handleChangeMenuDrawer() {
            this.$store.commit("ISMENUDRAWER", !this.isMenuDrawer);
        },
        alarm() {
            this.myTaskVisible = true;
        },
        /**
         * tab点击循环menulist获取menu_id的递归
         */
        tabRecursion(_target, list) {
            for (let i in list) {
                if (_target == list[i].url) {
                    return list[i].id;
                } else if (list[i].child && list[i].child.length) {
                    let func = this.tabRecursion(_target, list[i].child);
                    if (func) {
                        return func;
                    }
                }
            }
            return "";
        },
        download() {
            // let menuBread = [];
            // menuBread.push({
            //     name: "我的下载",
            //     path: "/download",
            // });
            // localStorage.setItem("menuBread", JSON.stringify(menuBread));
            // this.$store.commit("MENUBREAD", menuBread);
            this.$router.push("/download");
        },
        openHelp() {
            window.open(
                "https://shimo.im/docs/WDqjdgHQxcgRcCDR/read",
                "_blank"
            );
        },
        platform() {
            cmofferApi
                .platform(
                    {
                        menu_id: this.menu_id,
                    },
                    "get"
                )
                .then((res) => {
                    if (res) {
                        this.platformList = res.data;
                    }
                });
        },
        contact() {
            cmofferApi
                .getContactUser(
                    {},
                    "get"
                )
                .then((res) => {
                    console.log(res.data)
                    if (res) {
                        this.contactUserName = res.data.username ? res.data.username : "";
                        this.contactEmail = res.data.contact_email ? res.data.contact_email : "";
                    }
                });
        },
        chiocePlatform(item) {
            this.platform_id = item.id;
            this.addVisible = true;
            this.authorizedStore = false;
        },
        toshoppingCart() {
            this.$router.push({
                name: "shoppingCart",
            });
        },
        findProduct() {
            this.$router.replace({
                path: "/goodsList",
                query: {
                    keyword: this.keyword,
                },
            });
            this.keyword = "";
            this.$ga.event("engagement", "search", "search_term");
        },
        successCloseDialog(row) {
            this.authVisible = true;
            this.tableItem = row;
            if (row.platform_id == 3) {
                this.authKeyList = [
                    { key: "appid", name: "AppId" },
                    { key: "secret", name: "Secret" },
                    { key: "access_token", name: "Access Token" },
                    { key: "shop", name: "Shop" },
                ];
            } else if (row.platform_id == 4) {
                this.authKeyList = [
                    { key: "AppKey", name: "AppKey" },
                    { key: "AppSecret", name: "AppSecret" },
                    { key: "Token", name: "Token" },
                    { key: "ShopURL", name: "Shop URL" },
                ];
            }
        },
    },
    watch: {
        cartNum: {
            handler(val) {
                this.cart = val; // 获取购物车数量
            },
            immediate: true,
        },
    },
    created() {
        this.platform();
        this.contact();
    },
};
</script>
<style lang="scss">
.main_header {
    width: 100%;
    background: #3d3d3d;
    color: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px 0 $border-color-base;
    box-sizing: border-box;
    padding: 0 !important;
    position: relative;
    border-top: 3px solid $color-primary;
    // z-index: 2001 !important;
    .header-left {
        // height: 100%;
        display: flex;
        flex: 1;
        // button {
        //     height: 50px;
        //     width: 50px;
        //     font-size: 24px;
        //     padding: 0;
        // }
        .logoCont {
            width: 200px;
            // background: $color-primary;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            padding: 0 8px;
            cursor: pointer;
            text-decoration: none;
            // &:hover {
            // background: $color-primary-light-1;
            // border-color: $color-primary-light-1;
            // color: #fff;
            // }
            .logoImg {
                height: 45px;
            }
            // .logoTitle {
            //     color: $color-white;
            //     font-weight: 600;
            //     font-size: 18px;
            // }
        }
        .search {
            margin: 2px 0 0 20px;
            position: relative;
            width: 70%;
            .el-input {
                width: 100%;
                position: absolute;
                height: 40px;
                line-height: 40px;
                left: 0;
                input[type="text"] {
                    height: 100%;
                    line-height: 100%;
                    border-radius: 20px;
                    width: 100%;
                    border-color: $color-primary;
                    // background: #f2f2f2;
                    font-size: 14px;
                    padding-left: 30px;
                    &:focus {
                        border-color: $color-primary;
                    }
                }
            }
            button {
                border-radius: 20px;
                height: 40px;
                right: 0;
                position: absolute;
                padding: 0 25px;
                i {
                    font-weight: bold;
                    font-size: 16px;
                }
            }
        }
        .authorized {
            display: flex;
            align-items: center;
            cursor: pointer;
            p {
                font-size: 18px;
                // font-weight: bold;
                margin-left: 30px;
            }
        }
    }
    .header-right {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        flex-shrink: 0;
        .welcome {
            font-size: 14px;
            padding-right: 16px;
            text-align: right;
            line-height: 16px;
        }
        .store-img {
            margin-right: 12px;
            font-size: 14px;
            img {
                margin-right: 5px;
                width: 22px;
            }
        }
        .cart {
            margin-right: 20px;
            position: relative;
            user-select: none;
            cursor: pointer;
            i {
                font-size: 22px;
            }
            .cart-num {
                position: absolute;
                background-color: $color-primary;
                width: 20px;
                height: 20px;
                top: -8px;
                right: -10px;
                border-radius: 50%;
                color: #ffffff;
                font-size: 12px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            &:active {
                opacity: 0.6;
            }
        }
        .languageSpan {
            margin: 0 8px;
            cursor: pointer;
            color: #fff;
            font-size: 13px;
        }
        .questionCont {
            margin: 0 8px;
            cursor: pointer;
        }
        .questionCont,
        .downloadCont,
        .alarmCont {
            width: 40px;
            display: flex;
            justify-items: center;
            justify-content: center;
            &:hover {
                color: $color-primary;
            }
            i {
                font-size: 18px;
            }
        }
        .userinfo {
            display: inline-flex;
            align-items: center;
            justify-content: space-around;
            // width: 100px;
            color: $color-text-primary;
            margin-right: 10px;
            cursor: pointer;
            .userName {
                font-size: 14px;
                cursor: default;
                vertical-align: top;
                color: #fff;
                box-sizing: border-box;
                line-height: 28px;
                margin-left: 5px;
            }
            &:hover {
                color: $color-primary;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
</style>
